
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { append, toArray as toArray_1, empty, singleton, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Button } from "../../Components/Button.js";
import { RouterModule_encodeQueryString, RouterModule_encodeParts, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { singleton as singleton_1, empty as empty_1, toArray, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { TableContainer } from "../../Widgets/Container.js";
import { Table } from "../../Widgets/Table/Table.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { StocktakingState__ToI18nString } from "../../Shared/Stocktaking.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { StocktakingId__get_unwrap } from "../../Shared/Shared.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initOverviewStocktaking } from "./State.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { withoutOnboardingTourQueryParams, isStocktakingTourOverviewPhase } from "../../Common.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../Components/TourGuide.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { InformationAlert } from "../../Components/Alert.js";

export function OverviewTable(props) {
    let elems_2, elems_1, elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "mb-3", "justify-items-end"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["grow"]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["justify-self-end"])], (elems = toList(delay(() => (props.CanCreate ? singleton(createElement(Button, {
        ComponentState: "enabled",
        Label: t("stocktaking.new_stocktaking"),
        OnClick: () => {
            RouterModule_nav(ofArray(["stocktaking", "new"]), 1, 1);
        },
        TestId: "stocktaking-overview-new-stocktaking-button",
        Variant: "primary",
    })) : empty()))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(TableContainer, {
        Content: createElement(Table, (TableRows = toArray(props.Stocktakings), {
            ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("description", "", t("general.description"), (dto_1) => (new CellContent(0, [dto_1.Description])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("startDate", "", t("general.start_date"), (dto_2) => (new CellContent(8, [dto_2.StartDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("endDate", "", t("general.end_date"), (dto_3) => (new CellContent(8, [dto_3.EndDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("state", "", t("general.state"), (dto_4) => (new CellContent(0, [t(StocktakingState__ToI18nString(dto_4.State))])), "select", "text")), delay(() => (props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_5) => (new CellContent(0, [defaultArg(dto_5.BusinessUnitName, "")])), "select", "text")) : empty()))))))))))))),
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultColumnFilter: singleton_1({
                    id: "state",
                    value: [t("stocktaking.state.planned"), t("stocktaking.state.fixed"), t("stocktaking.state.started"), t("stocktaking.state.done")],
                }),
                DefaultSortColumn: ["startDate", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                OnRowClick: new OnTableRowClick$1(1, [(stocktaking) => RouterModule_encodeParts(ofArray(["stocktaking", StocktakingId__get_unwrap(stocktaking.Id)]), 1)]),
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        })),
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function StocktakingOverviewContent(props) {
    let elems;
    const t = useTranslation()[0];
    const state_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initOverviewStocktaking, update_1, (_arg, _arg_1) => {
    }), undefined, undefined)[0];
    const patternInput_2 = reactApi.useState(false);
    const setStocktakingOverviewTourDismissed = patternInput_2[1];
    const showStocktakingOverviewTour = (isFeatureEnabled(new Feature(4, [])) && isStocktakingTourOverviewPhase()) && !patternInput_2[0];
    const matchValue = state_1.Stocktakings;
    const matchValue_1 = state_1.AccountSettings;
    let matchResult, accountSettings, stocktakings;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_1.fields[0];
        stocktakings = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems = toList(delay(() => append(singleton(createElement(OverviewTable, {
                AccountSettings: accountSettings,
                CanCreate: props.CanCreate,
                Stocktakings: stocktakings,
            })), delay(() => {
                let Steps;
                return showStocktakingOverviewTour ? singleton(createElement(TourGuide, (Steps = singleton_1(new TourStep("[data-test-id=\'stocktaking-overview-new-stocktaking-button\']", t("onboarding.tour.stocktaking_tour_overview_new_title"), reactElement("div", {
                    children: t("onboarding.tour.stocktaking_tour_overview_new_content"),
                }), "bottom", true)), {
                    IsRunning: true,
                    Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                    OnFinish: () => {
                        setStocktakingOverviewTourDismissed(true);
                        RouterModule_nav(ofArray(["stocktaking", "new" + RouterModule_encodeQueryString(singleton_1(["onboardingTourStep", "stocktaking-step"]))]), 1, 1);
                    },
                    OnSkip: () => {
                        setStocktakingOverviewTourDismissed(true);
                        RouterModule_nav(singleton_1("stocktaking" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())), 1, 1);
                    },
                    ScrollFirstStep: true,
                    Steps: Steps,
                }))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

export function StocktakingOverview(props) {
    let elems;
    if (props.AccountSettings.InventoryEnabled) {
        return createElement(StocktakingOverviewContent, {
            AccountSettings: props.AccountSettings,
            CanCreate: props.CanCreate,
        });
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["w-10/12"])], (elems = [createElement(InformationAlert, {
            Label: "settings.stocktaking.not_enabled_info",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

